module.exports = __webpack_public_path__ + "Roboto-Bold.ad140ff02a7091257e2b.woff";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-Bold.woff
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-Bold.woff
// module chunks = 5